import React from 'react';
import PropTypes from 'prop-types';
import i18n from '@i18next/i18n';

interface ITabstopsToBeClearedProps {
    tabstops?: number[];
    isRemovingAll?: boolean;
}

const TabstopsToBeCleared: React.FC<ITabstopsToBeClearedProps> = ({ tabstops, isRemovingAll }) => (
    isRemovingAll ? <div>{i18n.t('全部')}</div>
        : <div>
            {tabstops?.map(tabstopPosition => tabstopPosition + i18n.t('厘米')).join(', ')}
        </div>
);

TabstopsToBeCleared.propTypes = {
    tabstops: PropTypes.array,
    isRemovingAll: PropTypes.bool,
};

export default TabstopsToBeCleared;
